import(/* webpackMode: "eager" */ "/opt/apps/wisprs/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/apps/wisprs/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["DocCodeBlockClient"] */ "/opt/apps/wisprs/src/components/developer/doc-code-block.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MultiLangCodeBlockClient"] */ "/opt/apps/wisprs/src/components/developer/multi-lang-code-block.tsx");
